import React from 'react'

const Photo = (props) => (
    <svg width="15" height="15" viewBox="0 0 15 15" fill={props ? props.color : '#000000'}
         xmlns="http://www.w3.org/2000/svg">
        <g opacity={props ? props.opacity : '0.5'}>
            <path
                d="M13.125 0H1.875C0.840912 0 0 0.840912 0 1.875V13.125C0 14.1591 0.840912 15 1.875 15H13.125C14.1591 15 15 14.1591 15 13.125V1.875C15 0.840912 14.1591 0 13.125 0ZM1.875 1.25H13.125C13.4697 1.25 13.75 1.5303 13.75 1.875V6.30371L11.6919 4.24561C11.4478 4.00162 11.0522 4.00162 10.8081 4.24561L6.40625 8.64746L4.81689 7.05811C4.57275 6.81412 4.17725 6.81412 3.93311 7.05811L1.25 9.74121V1.875C1.25 1.5303 1.5303 1.25 1.875 1.25ZM13.125 13.75H1.875C1.5303 13.75 1.25 13.4697 1.25 13.125V11.5088L4.375 8.38379L7.99561 12.0041C8.11783 12.1266 8.27744 12.1875 8.4375 12.1875C8.59756 12.1875 8.75717 12.1266 8.87939 12.0044C9.12338 11.7603 9.12338 11.3647 8.87939 11.1206L7.29004 9.53125L11.25 5.57159L13.75 8.07159V13.125C13.75 13.4697 13.4697 13.75 13.125 13.75Z"
                />
            <path
                d="M5 3.75C5 4.44031 4.44031 5 3.75 5C3.05969 5 2.5 4.44031 2.5 3.75C2.5 3.05969 3.05969 2.5 3.75 2.5C4.44031 2.5 5 3.05969 5 3.75Z"
                />
        </g>
    </svg>
)

export default Photo
